export class Sender {
  constructor(sender = {}) {
    this.id = parseInt(sender.id, 0);
    this.name = sender.name;
    this.type = sender.type;
  }
}
